import type { UploadFile, VideoType } from 'lib/media-upload-file';
import type { Media } from 'models';
import { useCallback } from 'react';
import { type FormInstance, message } from 'ui';
import { useDeleteMediaMutation } from 'features/media';
import { useUpdateVideoMutation } from '../../../../../queries';

type P = {
  file?: UploadFile;
  form: FormInstance;
  formName: string;
  mediaData?: Media;
  ref: string;
  removeUploadFromContext: () => void;
  type: VideoType;
};

export const useRemoveUpload = ({ file, form, formName, mediaData, ref, removeUploadFromContext, type }: P) => {
  const { mutate: updateVideo } = useUpdateVideoMutation();
  const { mutate: deleteMedia } = useDeleteMediaMutation();

  return useCallback(() => {
    // TODO: state done with upload doesnt mean CO is updated
    if (!file || file.state.status === 'done') {
      // TODO: Handle deleteMedia() -> updateVideo() sequence properly, something like this:
      // If updateVideo fails, retry fails as media already deleted, we want prevent that
      updateVideo(
        { data: { [type]: {} }, id: ref },
        {
          onSuccess() {
            deleteMedia(
              {
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion -- we assume that the data is available when the state is done
                id: mediaData!.id,
              },
              {
                onError() {
                  message.error('Failed to remove video');
                },
                onSuccess() {
                  message.success('Video removed successfully');
                  form.setFieldValue(formName, undefined);
                  removeUploadFromContext();
                },
              },
            );
          },
        },
      );
    } else {
      file.abort();
    }
  }, [file, updateVideo, ref, type, deleteMedia, mediaData, form, formName, removeUploadFromContext]);
};
